import PropTypes from 'prop-types';

export const entryTypeNameShape = PropTypes.shape({
    type: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    color: PropTypes.string,
});